import { createServiceClient } from "shared/welda/services/axiosClient";

const apiNotification = createServiceClient("/notification");

const sendNotifications = async (data) =>
  await apiNotification.post("/sendNotifications", data);

const GetLabels = async () => await apiNotification.get("/GetLabels");

const NewLabel = async (data) => await apiNotification.post("/newLabel", data);

const UpdateLabel = async (data) =>
  await apiNotification.post("/UpdateLabel", data);

const DeleteLabel = async (data) =>
  await apiNotification.post("/DeleteLabel", data);

const GetTemplates = async () => await apiNotification.get("/GetTemplates");

const NewTemplate = async (data) =>
  await apiNotification.post("/newTemplate", data);

const UpdateTemplate = async (data) =>
  await apiNotification.post("/UpdateTemplate", data);

const DeleteTemplate = async (data) =>
  await apiNotification.post("/DeleteTemplate", data);

const notificationService = {
  GetTemplates,
  NewTemplate,
  UpdateTemplate,
  DeleteTemplate,
  GetLabels,
  NewLabel,
  UpdateLabel,
  DeleteLabel,
  sendNotifications,
};

export default notificationService;
